import * as React from 'react';
import { PublicPageWrapper } from '../_pageWrappers/PublicPageWrapper';
import { PasswordResetConfirmationPanel } from './_components/PasswordResetConfirmationPanel';

export default function ConfirmPasswordResetPage (): JSX.Element
{
    return (
        <PublicPageWrapper>
            <PasswordResetConfirmationPanel />
        </PublicPageWrapper>
    );
}